import { Type } from 'class-transformer'
import { EnumEntity } from '..'
import { Expense } from '.'

export class ExpenseType extends EnumEntity {
  @Type(() => Expense)
  expenses: Expense[];
}
